var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33333 0C0.597333 0 0 0.597333 0 1.33333V9.33333C0 10.0693 0.597333 10.6667 1.33333 10.6667C2.06933 10.6667 2.66667 10.0693 2.66667 9.33333V1.33333C2.66667 0.597333 2.06933 0 1.33333 0ZM8 1.33333V9.33333C8 10.0693 7.40267 10.6667 6.66667 10.6667C5.93067 10.6667 5.33333 10.0693 5.33333 9.33333V1.33333C5.33333 0.597333 5.93067 0 6.66667 0C7.40267 0 8 0.597333 8 1.33333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.e52369076c69747b59c55fe279f4a420.svg";
export { ForwardRef as ReactComponent };